<template>
  <div>
    <div
      v-if="playerData"
      id="player"
      :class="{ 'full-screen': isFullScreen, 'preview': !isFullScreen }"
    />
    <div v-else>
      <div class="flex justify-center items-center">
        <div class="animate-spin rounded-full h-10 w-10 mr-4 border-b-2 border-matte-gray" />
        <h6>Loading...</h6>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, } from 'vue';
import { useNuxtApp, } from '#app';
import dateFormatUtil from '/utils/DateFormatterUtil.js';
import useFetchCustom from '~/composables/useFetchCustom';

export default {
  name: 'KalturaPlayer',
  props: {
    previewId: {
      type: String,
      required: true,
    },
    isFullScreen: {
      type: Boolean,
      required: false,
    },
    savePlayback: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { $auth: auth } = useNuxtApp();
    const route = useRoute();

    const isIphone = ref(false);
    const playerId = ref(null);
    const kalturaGetTime = ref(null);
    const playerData = reactive({
      targetId: 'player',
      partnerId: '2300171',
      uiConfId: '53973122',
    });

    const getKalturaTime = async() => {
      try {
        const response = await useFetchCustom('GET', `/account/kaltura/timestamp/${route.params.orderId}`);
        return response.timestamp;
      }
      catch (error) {
        console.error('Error fetching Kaltura time:', error);
      }
    };

    const playerPausedPost = async(timestamp) => {
      console.log('Inside player post');
      const data = {
        orderId: route.params.orderId,
        personId: auth.user.value.person_id,
        previewId: props.previewId,
        timestamp,
      };
      await useFetchCustom('POST', '/account/kaltura/timestamp', data).then((response) => {
        console.log('Player post response', response);
      });
    };

    onMounted(() => {
      isIphone.value = dateFormatUtil.isIphone();
      console.log('window', window);
      console.log('kwidget', window.kWidget);

      const script = document.createElement('script');
      script.src = 'https://cdnapisec.kaltura.com/p/2300171/embedPlaykitJs/uiconf_id/53973122';
      script.async = true;
      script.onload = () => {
        try {
          const kalturaPlayer = KalturaPlayer.setup({
            targetId: 'player',
            provider: {
              partnerId: playerData.partnerId,
              uiConfId: playerData.uiConfId,
            },
            playback: { autoplay: false },
          });

          kalturaPlayer.loadMedia({ entryId: props.previewId });

          if (props.savePlayback) {
            let currentTimeBeforeDestroy = null;

            kalturaPlayer.ready().then(async() => {
              kalturaGetTime.value = await getKalturaTime();
              kalturaPlayer.currentTime = kalturaGetTime.value;
            });

            kalturaPlayer.addEventListener(kalturaPlayer.Event.UI.USER_CLICKED_PLAY, () => {
              currentTimeBeforeDestroy = kalturaPlayer.currentTime;
            });

            kalturaPlayer.addEventListener(kalturaPlayer.Event.UI.USER_CLICKED_PAUSE, () => {
              const time = kalturaPlayer.currentTime;
              playerPausedPost(time);
            });

            setInterval(() => {
              const intervalTime = kalturaPlayer.currentTime;
              if (intervalTime !== null && intervalTime !== 0) {
                playerPausedPost(intervalTime);
              }
            }, 5 * 60 * 1000);
          }
        }
        catch (e) {
          console.error('Error embedding Kaltura Player:', e.message);
        }
      };
      document.head.appendChild(script);
    });

    return {
      isIphone,
      playerId,
      kalturaGetTime,
      playerData,
      getKalturaTime,
      playerPausedPost,
    };
  },
};
</script>

<style>
.preview {
  width: 450px;
  height: 250px;
}

.full-screen {
  width: 100%;
  height: 500px;
}

@media (width <= 820px) {
  .preview {
    width: 350px;
    height: 250px;
  }
}
</style>
